import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { AdjustmentStatus, StockAdjustmentInBatchState } from './StockAdjustmentInBatchTypes'

const selectFeature = (state: State) => state.stockAdjustmentInBatch

export const selectFileResultAvailable = createSelector(
  selectFeature,
  (state: StockAdjustmentInBatchState) => state.uploadFilePage.adjustment?.id
    && state.uploadFilePage.adjustment.status === AdjustmentStatus.INVALID,
)

export const selectAdjustment = createSelector(
  selectFeature,
  (state: StockAdjustmentInBatchState) => state.uploadFilePage.adjustment,
)

export const selectInvalidStructure = createSelector(
  selectFeature,
  (state: StockAdjustmentInBatchState) => state.uploadFilePage.invalidStructure,
)

export const selectPendingAdjustment = createSelector(
  selectFeature,
  (state: StockAdjustmentInBatchState) => state.pendingAdjustment,
)

export const selectAdjustmentDetails = createSelector(
  selectFeature,
  (state: StockAdjustmentInBatchState) => state.adjustmentDetails,
)

export const selectFilters = createSelector(
  selectFeature,
  (state: StockAdjustmentInBatchState) => state.filters,
)
